import { Component, OnInit, Inject, Optional } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { Product } from '../../masters/classes/product';
import { MasterProvider } from 'src/app/providers/master.provider';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TablerIconsModule,
  ],
  providers: [MasterProvider],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {

  constructor(public dialog: MatDialog,
    private toaster: ToastrService,
    private masterProvider: MasterProvider,) {
}

  pro_id:number = 0;
  pro_catid:number = 0;
  pro_status:string = 'Active';
  lowstock:string = 'No';
  dashboardCollectionList: any;


ngOnInit() {
  this.getProduct();
}


getProduct() {
  // this.dataSource = new MatTableDataSource([]);

  let saveObjFormData = new FormData();
  saveObjFormData.append('pro_id', this.pro_id.toString());
  saveObjFormData.append('pro_catid', this.pro_catid.toString());
  saveObjFormData.append('pro_status', this.pro_status.toString());
  saveObjFormData.append('lowstock', this.lowstock.toString());
  
  this.masterProvider.ProductList(saveObjFormData).subscribe(resp => {
    if (resp.responseCode === 200) {
      // let objProduct = Product.parseArray(resp.data);
      // this.dashboardCollectionList = resp.data[0];
      this.dashboardCollectionList = resp.data;
    } else {
      // this.toaster.error(resp.responseMessage);
    }
   
  }, error => {
    // this.isLoading = false;
    this.toaster.error('Something went wrong, Please try again later!');
  });
}

}
